import { PaintedScene } from '../PaintedScene';

export const ASH_PASS_PHASER_KEY = 'AshPassScene' as const;
export const ASH_PASS_MANIFEST_KEY = 's-408-ash-pass' as const;

export class AshPassScene extends PaintedScene {
  constructor() {
    super(ASH_PASS_PHASER_KEY, ASH_PASS_MANIFEST_KEY);
  }
}
